import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">视频合集</h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">按分类浏览海量吃瓜视频，快速找到你感兴趣的内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 border border-background-200/60 hover:border-primary-200/60 hover:bg-primary-50/30 transition-all group"
            >
              <span className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-semibold text-foreground-900">{item.title}</h3>
                <p className="text-sm text-foreground-500 mt-0.5">{item.count} 个视频</p>
              </div>
              <span className="w-7 h-7 flex items-center justify-center shrink-0">
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors text-lg"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}